export default {
    schedule_permission: { title: 'Timetable permissions' },
    home: {
        welcome: 'Welcome to the Student Information System',
        student: 'Student',
        view_profile: 'View student profile',
        try_again: 'Try again',
        quick_menu: 'Quick access',
        quick_menu_subtitle: 'Open your frequently used student services',
        student_information: 'Student information',
        student_information_detail: 'Review your personal and academic information',
        pre_registration_detail: 'Plan and submit your pre-registration',
        registration: 'Course registration',
        graduate_registration: 'Graduate registration',
        registration_detail: 'Register, add, change, or withdraw courses',
        timetable_detail: 'View courses, classrooms, and class times',
        exam_timetable_detail: 'Review exam dates, times, and rooms',
        payment_detail: 'Review and pay your tuition fees',
        academic_information: 'Academic Information',
        academic_information_subtitle: 'Current information from the student registry',
        no_academic_information: 'No academic information found',
        faculty: 'Faculty',
        department: 'Department',
        curriculum: 'Curriculum',
        branch: 'Major',
        level: 'Education Level',
        study_plan: 'Study Plan',
        admission_term: 'Admission Semester',
        student_type: 'Student Type',
        thai_student: 'Thai Student',
        international_student: 'International Student',
        admission_type: 'Admission Type',
        academic_advisor: 'Academic Advisor',
        thesis_advisor: 'Thesis / Independent Study Advisor',
        student_status: 'Student Status',
        currently_studying: 'Currently Studying',
        graduated: 'Graduated',
        council_approved: 'Council Approved',
        recommendation: 'Recommendations',
        check_information: 'Keep your information up to date',
        check_information_detail: 'If any information is incorrect, please contact your faculty registrar.',
        check_schedule: 'Check important dates regularly',
        check_schedule_detail: 'Review your class schedule, exam schedule, and payment due dates before proceeding.',
        load_error: 'Unable to load student information. Please try again.',
        surrogate_title: 'Surrogate student access',
        surrogate_subtitle: 'Enter the student ID you need to act on behalf of',
        surrogate_login: 'Continue as student',
        student_id: 'Student ID',
        student_id_required: 'Student ID is required',
        student_id_length: 'Student ID must contain 8 digits',
    },
    app_bar: {
        title: 'Registration System',
        homepage: 'Homepage',
        login: 'Login',
        logout: 'Logout',
        university_name: "King Mongkut's Institute of Technology Ladkrabang",
    },
    drawer: {
        main_menu: 'Main Menu',
        graduate_officer_menu: 'Graduate Officer Menu',
        user_account: 'User Account',
        surrogate_student: 'Surrogate Student',
        manual: 'Registration Manual',
        undergraduate: 'Undergraduate',
        postgraduate: 'Postgraduate',
        officer: 'Officer',
        teach_table: 'Timetable - Exam Schedule',
        registration_system: 'Registration System',
        pre_registration: 'Pre-Registration',
        registration: 'Registration / Add-Change-Withdraw',
        student_timetable: 'Personal Timetable',
        student_exam_timetable: 'Personal Exam Schedule',
        registration_future_innovation: '4+1 Registration',
        maintain_and_leave: 'Maintain / Leave of Absence',
        registration_for_officer: 'Registration',
        queue_list: 'Registration Waitlist',
        pay_tuition_fee: 'Pay Tuition Fee',
        for_officer: 'For Officers',
        payment: 'Payment',
        student_debt_report: 'Outstanding Tuition Report',
        academic_data_edit: 'Edit Academic Records',
        config: 'Configuration',
    },
    login: {
        google_authen_title: 'Google Authentication',
        google_authen_text: 'Use your university email account',
        university_authen_title: 'University Account Authentication',
        university_authen_text: 'Use your university account',
    },
    footer: {
        registrar: 'KMITL Registration and Educational Service Office',
        address1: '1 Soi Chalong Krung 1',
        address2: 'Ladkrabang Subdistrict, Ladkrabang District,',
        address3: 'Bangkok 10520',
        contact_undergraduate: 'Contact: Undergraduate',
        contact_graduate: 'Contact: Graduate',
        ext: "ext.",
    },
    toasted: {
        save_successfully: 'Saved successfully',
        cannot_save: 'Cannot save',
        create_successfully: 'Created successfully',
        cannot_create: 'Cannot create',
        cannot_upload_file: 'Cannot upload file',
        file_size_limit: 'File size exceeds the limit (4 MB)',
        delete_successfully: 'Deleted successfully',
        cannot_delete: 'Cannot delete',
        edit_successfully: 'Edited successfully',
        cannot_edit: 'Cannot edit',
        mail_sent: 'Your email has been sent',
        mail_sent_to: 'Email has been sent to',
    },
    config_teach_table: {
        subject_type: 'Subject type',
        subject_owner: 'Subject owner',
        subject_rule_type: 'Subject rule type',
        faculty: 'Faculty',
        department: 'Department',
        curriculum: 'Curriculum',
        class: 'Class Year',
        course_category: 'Course Category',
        course_id: 'Course ID',
        year: 'Academic Year',
        semester: 'Academic Semester',
        addnew: 'Add rule',
        save: 'Save',
        cancel: 'Cancel',
        save_data_successfully: 'Saved successfully. Please re-check the timetable.',
        save_unsuccessfully: 'Save failed. Please contact the Registrar\'s Office.',
        save_time_slot_successfully: 'Saved "class time slot" successfully',
        save_rule_slot_successfully: 'Saved "registration condition" successfully',
        save_teachtable_show_successfully: 'Saved "curriculum/class timetable display" successfully',
    },
    teach_table: {
        title: 'Timetable - Exam Schedule for Undergraduate Students',
        title_x: 'Timetable - Exam Schedule for Postgraduate Students',
        search_by_curr_class: 'Search by Curriculum / Class',
        search_by_curriculum: 'Search by Curriculum',
        search_by_major: 'Search by Major',
        search_by_course_id: 'Search by Course ID',
        search_by_course_name: 'Search by Course Name',
        search_by_course_category: 'Search by Course Category',
        graduate_search_subtitle: 'Search postgraduate class and examination schedules',
        admission_type: 'Admission Type',
        admission_semester: 'Admission Semester',
        branch: 'Major / Branch',
        major: 'Major',
        graduate_branch: 'Branch',
        selector_load_error: 'Unable to load selector data. Please try again.',
        select_all_faculty: 'Select all faculties',
        select_all_department: 'Select all departments',
        select_all_curriculum: 'Select all curricula',
        select_all_major: 'Select all majors',
        select_all_class: 'Select all class years',
        select_all_branch: 'Select all majors / branches',
        select_all_admission_type: 'Select all admission types',
        select_all_admission_semester: 'Select all admission semesters',
        search: 'Search',
        add_course_to_curr_class: 'Add Course to Curriculum / Class Timetable',
        searching: "Searching...",
        empty_data: "No results",
        empty_teach_table: "No timetable found",
        error: "Something went wrong",
        exam_text: {
            contact_instructor: "Contact instructor",
            contact_faculty: "Contact faculty",
            no_examination: "No examination",
        },
        course_id: "Course ID",
        course_name: "Course Name",
        credit: "Credit",
        credit2: "( Lecture - Practice - Research )",
        section: "Section",
        sec_pair: "Section Pair",
        teaching_date: "Teaching Date",
        room: "Room",
        building: "Building",
        lecturer: "Lecturer",
        exam_date: "Exam Date",
        condition: "Condition",
        seecondition: "See all",
        and: "and",
        note: "Note",
        limit: "Limit",
        pre_registered: "Pre-",
        pre_registered2: "enrolled",
        registered: "Enrolled",
        download: "Download",
        download_all: "Download All",
        queue: "In-queue",
        not_accept_other_students: "(Does not accept other students)",
    },
    room_timetable: {
        title: 'Classroom Timetable',
        subtitle: 'Find classroom usage for undergraduate and graduate courses',
        building: 'Building', room: 'Classroom', day: 'Day', level: 'Study level',
        undergraduate: 'Undergraduate', graduate: 'Graduate',
        invalid_link: 'Open this page using a classroom link in the teaching and exam timetable.',
        empty: 'No courses use this classroom in the selected term.',
        capacity: '{count} seats', detail_hint: 'Click a course for details and scheduled dates',
        no_time: 'Time not specified', actual_dates: 'Scheduled dates',
        course_details: 'Course details', retry: 'Retry', export_error: 'Download failed. Please try again.',
    },
    student_timetable: {
        title: 'Personal Timetable',
        subtitle: 'Class schedule from registered courses',
        year_semester: 'Academic Year',
        student_id: 'Student ID',
        updated_at: 'Updated at',
        no_registered_subject: 'No registered courses found for this semester.',
        registration_result: 'Registration result',
        print: 'Print',
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
    },
    queue_list: {
        title: 'Registration Waitlist',
        subtitle: 'View the registration waitlist by course and section.',
        year: 'Academic Year',
        semester: 'Semester',
        subject_id: 'Subject ID',
        section: 'Section',
        search: 'Search',
        clear: 'Clear Selection',
        error: 'Unable to retrieve the registration waitlist.',
        subject_name: 'Course Name',
        capacity: 'Capacity',
        unlimited: 'Unlimited',
        instructors: 'Instructors',
        no_subjects: 'No courses are available for this academic term.',
        student_id: 'Student ID',
        status: 'Status',
        waiting: 'Waiting',
        granted: 'Granted',
        expire_date: 'Expires At',
        created_date: 'Joined At',
        no_queue: 'No students are waiting for this course and section.',
    },
    student_exam_timetable: {
        title: 'Personal Exam Schedule',
        subtitle: 'Exam schedule from registered courses',
        year_semester: 'Academic Year',
        student_id: 'Student ID',
        updated_at: 'Updated at',
        no_exam: 'No exam schedule found for this semester.',
        exam_type: 'Exam Type',
        self_arranged: 'Defined by Instructor',
        exam_location: 'Building - Room - Seat',
        seat_map: 'Exam Room Seating Plan',
        room_front: 'Front of the room',
        assigned_seat: 'Your exam seat',
        other_seat: 'Other seat',
        no_seat: 'The exam room has not been assigned yet.',
        back_to_timetable: 'Back to exam schedule',
        building: 'Building',
        room: 'Room',
        seat: 'Exam seat',
        scroll_left_hint: 'Swipe left to view more of the seating plan',
    },
    lect_or_prac_chip: {
        practice: 'Practice',
        lecture: 'Lecture',
    },
    pre_registration: {
        registration_system: 'Pre-Registration for Undergraduate Students',
    },
    registration: {
        registration_system: 'Registration for Undergraduate Students',
        registration_system_x: 'Registration for Postgraduate Students',
        "registration_system_4+1": 'Registration for Future Innovation',
        registration_system_for_officer: 'Registration for Officers',
        subject_type_description: '* Credit (Cr) = Credit-bearing courses / Audit (Ad) = Audit courses / Transfer (Tr) = Transfer courses / Non Credit (Nc) = Non-credit courses',
        view_transaction: 'View Add / Change / Withdraw Transactions',
        add_subject: 'Add Subject',
        change_subject: 'Change Subject',
        withdraw_subject: 'Withdraw Subject',
        select_subject_to_change_out: 'Select subject to change out',
        select_subject_to_withdraw: 'Select subject to withdraw',
        select_subject_to_change_in: 'Select subject to change in',
        select_subject_to_add: 'Select subject to add',
        add: 'Add',
        change: 'Change',
        withdraw: 'Withdraw',
        continuous: 'Continuous',
        cancel: 'Cancel',
        confirm_title: 'Confirmation',
        confirm_text: 'Please verify that the information is correct. Once confirmed, this action cannot be undone.',
        confirm: 'Confirm',
        back: 'Back',
        regis_type_m_status: 'Status: Student status maintained.',
        regis_type_d_status: 'Status: Leave of absence.',
    },
    pre_regis_add_subject: {
        add_description: 'Enter the subject ID in the box below, then press the "ADD" button to add it to the list.',
        delete: 'Delete',
        list_subject_need_to_regis: 'List of subjects to register',
        early: 'In advance',
        subject_name: 'Subject Name',
        credit: 'Credit',
        section: 'Section',
        type: 'Credit Type',
        class_exam_timetable: 'Class/Exam Timetable',
        limit: 'Limit',
        number_of_people_registered: 'Registered',
        practice: '(practice)',
        add: 'Add',
        credits_that_student_can_take: 'Credits available to the student',
        please_contact_officer: 'Please contact the Registrar\'s Office.',
        all_registered_credits: 'All registered credits',
        continuous: 'Continue',
        grade_not_release: 'There are subjects whose grades have not yet been released',
        subject_id: 'Subject ID',
        prerequisite_has_no_grade: 'Some prerequisite subjects must be passed first, but their grades have not yet been released.',
        confirm_on_registration_date: 'On the actual registration date, if the grades issued do not meet the registration conditions, the system will cancel the course registration.',
        roger: 'Acknowledged',
        one_time_registration: 'Pre-registration may only be completed once.',
        one_time_regis_cannot_edit: 'Students may pre-register only once. After successful pre-registration, the result cannot be edited.',
        back: 'Back',
        confirm: 'Confirm',
        result: 'Result',
        waiting: 'Waiting',
        close: 'Close',
        error_in_taking_this_course: 'There was an error registering for the course: ',
        exam_collide: 'An exam date and time conflict with the selected subjects.',
        time_slot_collide: 'A class date and time conflict with the selected subjects.',
        prac_exam_collide: 'A practice exam date and time conflict with the selected subjects.',
        prac_time_slot_collide: 'A practice class date and time conflict with the selected subjects.',
        pre_registration_complete: 'Pre-Registration Complete',
        already_in_list: "This subject is already in the list.",
        case_subject_type_co_operative: "Cooperative education and internship courses cannot be taken with other courses in the same semester and cannot be withdrawn.",
        case_future_innovation_over_6_credit: "Future Innovation students may register for a maximum of 6 credits per semester.",
        defined_by_instructor: "Defined by Instructor",
    },
    regis_add_subject: {
        number_of_people_registered: 'Enrolled + In-queue',
        number_of_people_registered_x: 'Enrolled',
        one_time_registration: 'Regular registration may only be completed once.',
        one_time_regis_cannot_edit: 'Students may complete regular registration only once. Once registration is complete, the registration result cannot be edited. Courses may be added, changed, or withdrawn during the periods specified in the academic calendar.',
        some_courses_you_have_right_but_not_register: 'There are some courses for which you are eligible but have not registered.',
        if_registration_process_has_been_completed_will_be_deemed_to_have_waived_these_rights_immediately: 'Once you complete registration, you will be deemed to have waived these rights immediately.',
    },
    pre_regis_pageinfo: {
        registration_check_result: 'Registration / Check Result',
        not_yet_logged_in_or_not_at_given_time: 'The student did not log in or was inactive during the specified time.',
        back_to_log_in_page: 'Please go back to the Login page',
        go_to_log_in_page: 'Go to Login page',
        not_during_pre_registration_period: 'Not during the pre-registration period.',
        pre_registration_period: 'Pre-registration period',
        year: 'Academic Year',
        is: 'is',
        not_in_study_status_so_cant_pre_registrtion: "The student's status is not 'Studying'. The student is unable to pre-register.",
        student_1st_year_semester_1_cant_pre_register: 'First-year students in their first semester cannot pre-register.',
        because_registered_according_to_plan_for_student_1st_year_semester_1: 'The system has already registered first-year students in their first semester according to the study plan.',
        students_cant_pre_register_because: 'Students cannot pre-register because',
        have_any_inquiries_please_dont_hesitate_to_contact: 'If you have any questions, please contact the staff at',
        students_dont_pre_register_during_the_specified_period: 'The student did not pre-register during the specified period.',
    },
    regis_pageinfo: {
        not_during_registration_period: 'Not during the registration period.',
        registration_period: 'Registration period',
        not_in_study_status_so_cant_registrtion: "The student's status is not 'Studying'. The student is unable to register.",
        student_1st_year_semester_1_cant_register: 'First-year students in their first semester cannot register.',
        students_cant_register_because: 'Students cannot register because',
        students_dont_register_during_the_specified_period: 'Students did not complete regular registration during the specified period.',
        see_calendar: 'See Academic Calendar',
    },
    pre_regis_complete: {
        list_of_registered_subjects: 'List of registered subjects.',
        early: '(In advance)',
        can_register: 'You are eligible.',
        can_not_register: 'You are not eligible. (In queue)',
        can_not_register_violate_condition: 'You are not eligible because the conditions were not met.',
    },
    information: {
        undergraduate: 'Undergraduate',
        postgraduate: 'Postgraduate',
        title: 'Registration instructions',
        no_1: '1. You have to register on your own.',
        no_2: '2. You should check your registered courses',
        no_2cut1: 'according to the curriculum.',
        no_3: '3. At the end of pre-registration, the system will randomly select eligible students.',
        no_3cut1: 'The order of pre-registration does not affect eligibility.',
        no_4: '4. After completing pre-registration, you must check the pre-registration result in the system on the announced result date.',
        student: 'All students',
        no_5cut1: 'must enroll in regular registration.',
        no_6: 'Regular Registration Period',
        no_6_1: '6.1 Students who are eligible for courses during the pre-registration period',
        no_6_1cut1: 'must enroll in regular registration',
        no_6_1cut2: 'to confirm their eligibility for pre-registration.',
        no_6_2: '6.2 Students who are not eligible for courses during the pre-registration period',
        no_6_2cut1: 'must enroll in regular registration',
        no_6_2cut2: 'to confirm enrollment in the courses they wish to study, including courses for which they were not eligible during pre-registration.',
        no_6_3: '6.3 Students who do not register during the pre-registration period',
        no_6_3cut1: 'must enroll in regular registration',
        no_6_3cut2: 'to register for courses according to the conditions of their own curriculum.',
        no_6_4: '6.4 Students may complete regular registration',
        no_6_4cut1: 'only once.',
        no_6_4cut2: 'If a student wishes to add additional courses, the student may do so during the Add/Change/Withdraw period.',
        no_7: 'Add/Change/Withdraw Period',
        no_7_1: 'Students who were not eligible for courses during pre-registration and confirmed enrollment during regular registration will be placed on the waiting list. When seats become available, the system will notify students in queue order via the Institute email address (xxxxxxxx@kmitl.ac.th). Students who receive the notification must register during the add/change/withdrawal period within the time specified in the email.',
        no_7_2: 'Students who completed regular registration and would like to add, change, or withdraw courses must log in during the period specified in the academic calendar.',
        accept: 'Back to main page',
        grad_no_0: '* Postgraduate students are not required to pre-register.',
    },
    pre_regis_flow_chart: {
        next: 'Enter the registration process.',
    },
    pre_regis_stepper: {
        start: 'Start',
        select_subject: 'Select Subjects',
        complete: 'Complete',
        curriculum: "Curriculum on KRESO's Website",
        curriculumOAQ: "Curriculum on OAQ's Website",
        timetable: 'Timetable',
        academic_calendar: 'Academic Calendar',
    },
    pre_regis_panel: {
        student_id: 'Student ID',
        name_surname: 'Name - Surname',
        semester: 'Semester',
    },
    queue_table_panel: {
        subjects_eligible_for_registration: 'Courses you are eligible to register for',
        details: '(Please select the subject for which you would like to use your eligibility, then enter the subject code in the "List of subjects to register" above.)',
        entitled_to: 'Last day of eligibility',
        waiver: 'Waive',
        no_item: 'No items',
        retrospective_button: 'View Retrospective List',
        retrospective_list: 'Retrospective List',
        status: 'Status',
        time: 'Time',
        this_right_has_been_used_for_registration: 'This right was used in the registration.',
        this_right_is_not_used_for_registration: 'This right was not used for registration.',
        this_right_is_not_used_in_the_specified_period: 'This right was not used within the specified period.',
        student_manually_removed_from_the_waiting_list: 'The student removed themselves from the waiting list.',
        confirm_the_deletion_of_the_course_from_the_queue: 'Confirm deletion of the course from the queue.',
    },
    queue_table: {
        subjects_in_the_queue: 'Subjects in the queue',
        description: '(The queue limit may be reduced to fewer than 5 queues during the add/change course period.)',
        cancel_queue: 'Cancel the queue',
        no_itme: 'No items',
    },
    pattern_table: {
        course_registration_information: 'Course registration information',
        students_should_check_course_submission_according_to_the_course_plan: '(Students should check the course according to the curriculum plan)',
    },
    config_academic: {
        title: 'Registration Configuration',
        config_academic: 'Configure Registration Dates',
        addnew: 'Add New',
        sub_level_id: '4+1',
        year: 'Academic Year',
        semester: 'Semester',
        start_datetime_system: 'Academic year start date (for example, pre-registration opening date)',
        start_datetime_academic: 'Semester start date',
        end_datetime_academic: 'Semester end date',
        start_datetime_config_teach_table: 'Start date [timetable configuration]',
        end_datetime_config_teach_table: 'End date [timetable configuration]',
        start_datetime_midterm: 'Start date [midterm examination]',
        end_datetime_midterm: 'End date [midterm examination]',
        start_datetime_final: 'Start date [final examination]',
        end_datetime_final: 'End date [final examination]',
        start_datetime_pre_regis: 'Start date [pre-registration]',
        end_datetime_pre_regis: 'End date [pre-registration]',
        start_datetime_regis: 'Start date [regular registration]',
        end_datetime_regis: 'End date [regular registration]',
        start_datetime_add_change: 'Start date [add/change]',
        end_datetime_add_change: 'End date [add/change]',
        start_datetime_withdraw: 'Start date [withdrawal]',
        end_datetime_withdraw: 'End date [withdrawal]',
        edit: 'Edit',
        delete: 'Delete',
        confirm: 'Confirm',
        cancel: 'Cancel',
        save: 'Save',
        confirm_delete: 'Confirm Delete',
    },
    config_payment: {
        config_payment: 'Payment Configuration',
        start_datetime_no_charge: 'First day [payment without penalty]',
        end_datetime_no_charge: 'Last day [payment without penalty]',
        start_datetime_regist_charge: 'First day [late registration penalty]',
        end_datetime_regist_charge: 'Last day [late registration penalty]',
        regist_charge: 'Penalty [late registration]',
        start_datetime_pay_late_charge: 'First day [late payment penalty]',
        end_datetime_pay_late_charge: 'Last day [late payment penalty]',
        pay_late_charge_per_day: 'Penalty per day [late payment]',
        last_datetime_pay_date: 'Last day [payment]',
        amount: 'Amount',
    },
    config_medicine: {
        title: 'Faculty of Medicine Configuration',
        subtitle: 'List of students training or studying at Sirindhorn Hospital for tuition fee allocation',
        student_id: 'Student ID',
        name: 'Name - Surname',
        date: 'Recorded Date',
    },
    regis_transaction: {
        title: "Add / Change / Withdraw Transaction",
        order: "Order",
        type: "Registration Type",
        subject_id: "Subject ID",
        subject_name: "Subject Name",
        section: "Section",
        timestamp: "Timestamp",
        tran_type_r: "Regis",
        tran_type_a: "Add",
        tran_type_c: "Change",
        tran_type_d: "Withdraw",
        changed_to: "changed to",
    },
    payment: {
        title: 'Payment System',
        officer_title: 'Payment System for Officers',
        search: 'Search',
        load_error: 'Unable to load payment information. Please try again.',
        student_mode_unavailable: 'Unable to verify student payment conditions. Please contact the system administrator.',
        system_undergraduate: 'Undergraduate',
        system_graduate: 'Postgraduate',
        "system_4+1": 'Future Innovation',
        year: 'Academic Year',
        transaction: 'Transactions',
        tuition_fee: 'Tuition fees',
        tuition_fee_header_1: 'Tuition',
        tuition_fee_header_2: 'fees',
        discount: 'Discount from the institute',
        discount_header_1: 'Institute',
        discount_header_2: 'discount',
        other_fee: 'Other fees',
        other_fee_header_1: 'Other',
        other_fee_header_2: 'fees',
        subsidy_fee: 'Education subsidy fee',
        thesis_fee: 'Thesis examination fee',
        compre_fee: 'Comprehensive examination fee',
        qe_fee: 'Qualification examination fee',
        late_chart: 'Charge for late registration',
        late_chart_header_1: 'Late registration',
        late_chart_header_2: 'charge',
        pay_chart: 'Charge for late payment',
        pay_chart_header_1: 'Late payment',
        pay_chart_header_2: 'charge',
        first_year_first_semester_no_pay_charge: 'No late payment charge for first-year students in their first semester',
        paid: 'Paid',
        remain: 'Remaining balance',
        print: 'Payment',
        complete: 'Paid in full',
        note_late_chart: '*** Students who register late must pay a late registration penalty of 300 Baht. ***',
        note_pay_chart_1: '*** Students who pay tuition fees late must pay a daily late payment penalty of',
        note_pay_chart_2: 'Baht/day) ***',
        notification: 'Notification',
        notification_1: 'Failure to make payment by the due date specified in the tuition fee payment slip will result in the inability to process the transaction. Students are strongly encouraged to review the payment amount and final payment deadline stated in the tuition fee payment slip to ensure accuracy and compliance.',
        notification_2: 'If the intended payment date coincides with the final payment deadline, please complete the payment before 11:00 PM.',
        notification_3: 'During the daily late-payment-fee period, payments may be made from 1:00 AM to 10:59 PM. Payments are unavailable from 11:00 PM to 12:59 AM.',
        credit_card: 'Credit Card',
        billing: '= Receipt available',
        request_receipt: 'Request a receipt',
        edit: 'Edit',
        delete: 'Delete',
        order: 'No.',
        actions: 'Actions',
        save: 'Save',
        cancel: 'Cancel',
        baht: 'Baht',
        edit_tuition_fee: 'Edit tuition fee',
        leave_fee: 'Leave of absence fee',
        edit_leave_fee: 'Edit leave of absence fee',
        maintain_fee: 'Student status maintenance fee',
        edit_maintain_fee: 'Edit student status maintenance fee',
        edit_other_fees: 'Edit other fees',
        view_other_fees: 'View other fee details',
        other_fee_details: 'Other fee details',
        edit_late_charge: 'Edit late registration charge (300 Baht)',
        exempt_late_charge: 'Exempt the Charge',
        add_late_charge: 'Not Exempt the Charge',
        select_late_charge_action: 'Select an action for the late registration charge.',
        edit_pay_charge: 'Edit late payment charge',
        exempt_pay_charge: 'Exempt the charge',
        add_pay_charge: 'Not Exempt the charge',
        select_pay_charge_action: 'Select an action for the late payment charge.',
        penalty_status_exempt: 'Charge exempted',
        penalty_status_charge: 'Charge calculated according to system rules',
        penalty_saved_status: 'Current status:',
        academic_period: 'Semester {semester} / {year}',
        amount_required: 'Please enter an amount.',
        amount_integer: 'The amount must be an integer.',
        amount_nonnegative_integer: 'The amount must be a non-negative integer.',
        update_success: 'The fee was saved successfully.',
        update_failed: 'Unable to save the fee.',
        edit_recalculate_note: 'After saving, the outstanding balance will be recalculated from the latest data.',
        confirm_update_title: 'Confirm payment information update',
        confirm_update_message: 'Please verify the information before confirming. This change will affect the amount used to calculate the student payment slip.',
        confirm_and_save: 'Confirm and save',
        education_level: 'Education level',
        faculty_college_campus: 'Faculty/College/Campus',
        registration_type: 'Registration type',
        change_details: 'Change details',
        current_value: 'Current value',
        new_value: 'New value',
        other_fee_total: 'Total other fees',
        current_payment_summary: 'Payment information before update',
        no_changes: 'There are no changes to save.',
        close: 'Close',
        view_only: 'View only',
        view_payment_details: 'View payment details',
        payment_details: 'Payment details',
        no_payment_details: 'No payment details were found for this academic term.',
        verified_payment_records: 'Receipted payments',
        registration_and_payment_records: 'Registration and payment records',
        pending_payment_records: 'Paid and pending verification',
        pending_payment_note: 'The bank has confirmed this payment, but it has not yet been matched to a registrar receipt.',
        receipt_number: 'Receipt number',
        receipt_count: '{count} receipt(s)',
        payment_date_time: 'Payment date and time',
        transaction_date: 'Transaction date',
        record_date: 'Date',
        payment_date: 'Payment date',
        payment_date_buddhist: 'Payment date (B.E.)',
        payment_date_buddhist_placeholder: 'Select payment date',
        select_payment_date: 'Select payment date',
        use_selected_date: 'Use selected date',
        invalid_buddhist_date: 'Please enter a valid date in DD/MM/B.E. format.',
        total_paid: 'Total paid',
        total: 'Total',
        bank: 'Bank / payment channel',
        bank_required: 'Please select a bank or payment channel.',
        no_billing_codes: 'No banks or payment channels were found.',
        no_billing_codes_for_level: 'No banks or payment channels were found for this education level.',
        billing_codes_load_failed: 'Unable to load banks or payment channels.',
        reference_number: 'Reference number',
        edit_payment_record: 'Edit payment details',
        create_payment_record: 'Record a payment',
        automatic_receipt_number: 'Generated automatically',
        billing_edit_recalculate_note: 'After saving, the total for this record will be recalculated from all fee items.',
        new_total: 'New total',
        confirm_billing_update_title: 'Confirm payment detail changes',
        confirm_billing_update_message: 'Please verify the student ID, academic term, receipt number, and changed values before confirming.',
        billing_update_success: 'Payment details have been updated.',
        confirm_billing_create_title: 'Confirm new payment record',
        confirm_billing_create_message: 'Please verify the student ID, academic term, payment date, bank, and amount. A receipt number will be generated automatically.',
        billing_create_success: 'The payment record has been created.',
        payment_record_number: 'Record {number}',
        registration_number: 'Registration number',
        registration_information: 'Registration information',
        registration_type_s: 'Normal registration',
        registration_type_m: 'Student status maintenance',
        registration_type_d: 'Leave of absence',
        registration_transaction_a: 'Add',
        registration_transaction_c: 'Change',
        registration_transaction_d: 'Withdraw',
        confirm_billing_delete_title: 'Confirm payment record deletion',
        confirm_billing_delete_message: 'Deleting this record will change the student payment total and payment status. Please verify the details and provide a reason before confirming.',
        delete_payment_record: 'Delete payment record',
        delete_reason: 'Reason for deletion',
        delete_reason_hint: 'Please enter at least 3 characters.',
        billing_delete_success: 'The payment record has been deleted.',
        billing_delete_failed: 'Unable to delete the payment record.',
        invalid_payment_data: 'Unable to read payment information. Please try again or contact the system administrator.',
        academic_period_label: 'Academic year / semester',
        billing_field_credit_fee: 'Credit fee',
        billing_field_package_fee: 'Tuition fee',
        billing_field_student_fee: 'Student registration fee',
        billing_field_student_card: 'Student card fee',
        billing_field_health_check: 'Health check fee',
        billing_field_institute_fee: 'Institute fee',
        billing_field_library_fee: 'Library fee',
        billing_field_internet_fee: 'Internet service fee',
        billing_field_health_service: 'Health service fee',
        billing_field_sport_fee: 'Sport service fee',
        billing_field_activity_fee: 'Student activity fee',
        billing_field_accident_insure: 'Accident insurance fee',
        billing_field_leave_fee: 'Leave of absence fee',
        billing_field_maintain_fee: 'Student status maintenance fee',
        billing_field_special_fee1: 'Special fee 1',
        billing_field_special_fee2: 'Institute discount',
        billing_field_subsidy_fee: 'Education subsidy',
        billing_field_late_charge: 'Late registration charge',
        billing_field_pay_charge: 'Late payment charge',
        billing_field_else: 'Other',
        billing_field_document_fee: 'Document service fee',
        billing_field_property_insure: 'Property insurance fee',
        billing_field_thesis_fee: 'Thesis examination fee',
        billing_field_comp_fee: 'Comprehensive examination fee',
        billing_field_qe_fee: 'Qualification examination fee',
        student_notes: 'Student notes',
        add_student_note: 'Add a note',
        student_note_history: 'Note history',
        student_note_date: 'Date and time',
        student_note_message: 'Message',
        student_note_author: 'Recorded by',
        student_note_placeholder: 'Enter a note about this student',
        student_note_required: 'Please enter a message.',
        student_note_too_long: 'The message must not exceed 2,000 characters.',
        save_student_note: 'Save note',
        no_student_notes: 'No notes have been recorded for this student.',
        student_note_load_failed: 'Unable to load student notes.',
        student_note_saved: 'The note has been saved.',
        student_note_updated: 'The note has been updated.',
        student_note_deleted: 'The note has been deleted.',
        confirm_student_note_delete: 'Confirm note deletion',
        confirm_student_note_delete_message: 'This note will be hidden from the history. Do you want to delete it?',
    },
    english_graduate: {
        title: "English Proficiency Submission for Graduate Students",
        title_short: "English Proficiency Submission System",
        submit_english_score: "Submit English Score",
        officer_title_short: "Verify English Submission",
        student_id: "Student ID",
        name: "Name",
        surname: "Surname",
        admis_year: "Admission Year",
        level: "Educational Level",
        curriculum_type: "Program",
        faculty: "Faculty / College",
        curriculum: "Curriculum",
        master_warning: "Master's degree students who enroll in and pass 2 English subjects will immediately satisfy the English proficiency requirement without submitting additional evidence.",
        doctor_warning: "If the initial score does not meet the specified criterion, the requirement must be met within 1 year from the admission academic year.",
        english_status: "English Language Proficiency Status",
        english_subject: "English Subject",
        check_english: "Check the English proficiency requirements here",
        english_history: "History of English Proficiency Requirement Submissions",
        times: "Attempt",
        append_date: "Submission date",
        criteria: "Criteria",
        exam_type: "Exam type",
        check_status: "Status",
        approved_date: "Approved date",
        approver: "Approver",
        no_record: "(No submission history)",
        open_form: "Request Form",
        form_title: "English Proficiency Requirements Form",
        select_criteria: "Criteria for submission",
        select_exam: "Exam type",
        score: "Score",
        pass_date: "Test date",
        upload: "Upload file (Evidence)",
        submit: "Submit",
        list_student: "List of English Proficiency Requirement Submissions",
        year: "Year",
        semester: "Semester",
        verify: "Verify",
        officer_page: "English Proficiency Requirement Requests (Officer Review)",
        basic: "Basic Information",
        form: "Student's Form",
        student_english_status: "English language proficiency status of this student",
        set_score: "Required score",
        proof: "Evidence",
        comment: "Comment",
        pass: "Pass",
        not_pass: "Not Passed",
        current_status: "Current status of the request",
    },
    questionnaire: {
        title:
            "Satisfaction Questionnaire for the Registration System",
        title_short: "Questionnaire",
        general_information: "General information of the respondents.",
        level_satisfaction_user: "Satisfaction level of service users",
        header_table1: "Criteria",
        header_table2: "Level (1: Very dissatisfied to 5: Very satisfied)",
        header_table2_hint:
            "(Please rate your satisfaction.)",
        Q1: "1. Students understand the regulations and rules related to course registration.",
        Q2: "2. Students have checked the academic calendar announced by the institute for the academic year before registration.",
        Q3: "3. Students understand the process of advance registration, regular course registration, adding or changing courses, as well as the period for course withdrawal according to the academic calendar.",
        Q4: "4. The course registration system is user-friendly for students.",
        Q5: "5. When students encounter problems or have questions about course registration, they may contact the Registrar's Office through various channels, such as its Facebook page, telephone, or email.",
        Q6: "6. Overall satisfaction with course registration.",
        additional_info: "Additional Information",
        additional: "Additional suggestions / Other suggestions",
        please_rate: "Please rate",
    },
    maintain: {
        title: "Maintaining Student Status / Leave of Absence",
        basic_info: "If you wish to maintain your student status or take a leave of absence, please contact the Registration Section of your faculty.",
        basic_info_x: "If you wish to maintain your student status or take a leave of absence, please contact the Graduate Section of your faculty.",
    },
    officer: {
        config_subsidy_fee: "Configure tuition fee and subsidies",
        config_individual_tuition_fee: "Configure individual student tuition fee",
        report_student_not_registered: "Report of students who have not registered",
    },
};
